module.exports = __webpack_public_path__ + "static/img/GettyImages-861223590.90bc65f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-861223590.jpg
// module id = l6Eo
// module chunks = 0